import { render, staticRenderFns } from "./PaperEnclosureQuestion.vue?vue&type=template&id=42f35e58&lang=pug"
import script from "./PaperEnclosureQuestion.vue?vue&type=script&lang=ts"
export * from "./PaperEnclosureQuestion.vue?vue&type=script&lang=ts"
import style0 from "./PaperEnclosureQuestion.vue?vue&type=style&index=0&id=42f35e58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports